import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=2aace4da&scoped=true"
import script from "./Collapsible.vue?vue&type=script&setup=true&lang=js"
export * from "./Collapsible.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=2aace4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aace4da",
  null
  
)

export default component.exports